export default "__VITE_PUBLIC_ASSET__9df5d3b3__"